/*
  VINERACK CUSTOMISATION — explicit .play()/.pause() for gallery product videos.

  The HTML `autoplay` attribute alone is not reliable for a <video> that starts
  off-screen inside a horizontal slider (a slide the shopper hasn't swiped to
  yet). Some mobile browsers only honour autoplay once the element has actually
  intersected the viewport, and Shopify's own deferred-media.js works around
  the same limitation by calling video.play() explicitly ("force autoplay for
  safari"). This does the same thing via IntersectionObserver, so each product
  video starts the instant its slide scrolls into view, on both mobile and
  desktop, with or without the theme's optional thumbnail strip.
*/
(function () {
  if (window.__vinerackVideoAutoplayLoaded) return;
  window.__vinerackVideoAutoplayLoaded = true;

  function attemptPlay(video) {
    var playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(function () {
        // Autoplay blocked (e.g. Data Saver). Native controls remain as a fallback.
      });
    }
  }

  function observe(video) {
    if (video.dataset.vinerackObserved) return;
    video.dataset.vinerackObserved = 'true';

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            attemptPlay(entry.target);
          } else {
            entry.target.pause();
          }
        });
      },
      { threshold: 0.5 }
    );
    io.observe(video);
  }

  function scan() {
    document.querySelectorAll('video[data-vinerack-autoplay]').forEach(observe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Re-scan after Shopify section reloads (theme editor, quick-add, variant swaps).
  document.addEventListener('shopify:section:load', scan);
})();
